<template lang="pug">
#modal-tutorial.modal.show(tabindex='-1' role='dialog')
  .modal-dialog.modal-dialog-centered.modal-form(role='document')
    .modal-content
      //- div.position-absolute.close-button 
      //-   i.fa-solid.fa-x
      .position-absolute.close-button.pointer(@click="closeTutorial")
        i.fa-solid.fa-x.fa-2x
      .modal-body
        img.img-fluid(src='assets/img/ios.jpg')
</template>
<script>
export default {
  methods:{
    closeTutorial(){
      $("#modal-tutorial").modal("hide")
    }
  }
}
</script>
<style lang="scss" scoped>
.close-button{
  z-index: 1;
  // border-radius: 50%;
  // padding: 0.5em;
  // width: 30px;
  // height: 30px;
  // border: 2px solid#8127c5;
  color: #fff;
  top: 10px;
  right: 10px;
}
</style>